"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemConfigSelection = void 0;
const core_1 = require("@angular/core");
const notification_service_1 = require("./notification.service");
const search_custom_pipe_1 = require("./search-custom.pipe");
let LineItemConfigSelection = class LineItemConfigSelection {
    constructor(_talk, _searchCustom) {
        this._talk = _talk;
        this._searchCustom = _searchCustom;
        this.listPage = 1;
        this.searchTerm = '';
        //Maximum creative IDS selection a user can make;
        this.MAX_CREATIVE_IDS_SELECTION = 15;
        this.selection = {
            name: "",
            readCommand: "",
            id: "",
            values: null,
            selected: false,
            selectedValues: null,
            valuesSelectionType: 'multiple',
            status: { name: null, msg: null }
        };
        this.onSelectedValue = new core_1.EventEmitter();
        this.onUnselectedValue = new core_1.EventEmitter();
    }
    valueSelected(selectedOptionId, selectedValues) {
        //Verify if user have passed max selection limit for creatives
        if (!(this.selection.id == 'creativeIds' && (this.selection.selectedValues && this.selection.selectedValues.length) >= this.MAX_CREATIVE_IDS_SELECTION))
            this.onSelectedValue.emit({ selectedOptionId, selectedValues });
        else
            this._talk.broadcast('<h2>Selection Limit Reached</h2>');
    }
    valueUnselected(selectedOptionId, unselectedValue) {
        this.onUnselectedValue.emit({ selectedOptionId, unselectedValue });
    }
    /**
     * Allows to select all values of current selection Id
     * @param {any[]} menuOptionArray
     * @param {string} search
     * @param {boolean} value
     */
    changeSelectionOptions(menuOptionArray, search) {
        let options = this._searchCustom.transform(menuOptionArray, search, ['name']);
        let currentSelectionCount = this.selection.selectedValues ? this.selection.selectedValues.length : 0;
        for (let opt = 0; opt < options.length; opt++) {
            if (!options[opt].selected) {
                this.valueSelected(this.selection.id, options[opt]);
                currentSelectionCount += 1;
                //Check if creatives limit it's reached
                if (this.selection.id === 'creativeIds' && (currentSelectionCount >= this.MAX_CREATIVE_IDS_SELECTION)) {
                    return;
                }
            }
        }
    }
};
exports.LineItemConfigSelection = LineItemConfigSelection;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], LineItemConfigSelection.prototype, "selection", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], LineItemConfigSelection.prototype, "onSelectedValue", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], LineItemConfigSelection.prototype, "onUnselectedValue", void 0);
exports.LineItemConfigSelection = LineItemConfigSelection = __decorate([
    (0, core_1.Component)({
        selector: 'line-item-config-selection',
        templateUrl: 'app/line-item-config-selection.component.html',
        styleUrls: ['styles/less/line-item-config-selection.component.less']
    }),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        search_custom_pipe_1.SearchCustomPipe])
], LineItemConfigSelection);
//# sourceMappingURL=line-item-config-selection.component.js.map